import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzCardModule } from 'ng-zorro-antd/card';
import { TranslateModule } from '@ngx-translate/core';
import { ClassificationCodeService } from '@beautyapp/core';

@Component({
  selector: 'beautyapp-template-content-modal',
  standalone: true,
  imports: [
    NzTypographyModule,
    NzDividerComponent,
    NzCollapseModule,
    NzCardModule,
    TranslateModule
  ],
  templateUrl: './template-content-modal.component.html',
  styleUrl: './template-content-modal.component.scss'
})
export class TemplateContentModalComponent {
  data = inject(NZ_MODAL_DATA);
  classificationCodeService = inject(ClassificationCodeService);

  getIcdName(icdId: number | null): string | null {
    if (!icdId) return null;

    const findIcdInTree = (nodes: any[], id: number): any => {
      for (const node of nodes) {
        if (node.key === id || node.value === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = findIcdInTree(node.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const icdNode = findIcdInTree(this.classificationCodeService.classificationICDCodes(), icdId);
    return icdNode ? icdNode.title : null;
  }

  getIllnessType(illnessCode: number): string {
    const illnessTypes: { [key: number]: string } = {
      1: 'მწვავე',
      2: 'ქრონიკული',
      3: 'ქრონიკული გამწვავებული',
      4: 'არარსებობა',
      5: 'შემთხვევითი პოვნა'
    };
    return illnessTypes[illnessCode] || 'უცნობი';
  }

  getTreatmentTypeLabel(type: string): string {
    const types: { [key: string]: string } = {
      'CLINICAL_DIAGNOSTIC': 'კლინიკურ-დიაგნოსტიკური გამოკვლევა',
      'OTHER_ACTIVITY': 'თანმხლები აქტივობა',
      'LAB_TEST': 'ლაბორატორიული გამოკვლევები',
      'CONSULTATION': 'კონსულტაციები',
      'PRESCRIPTION': 'დანიშნულება',
      'TRANSFUSION': 'სისხლის გადასხმა',
      'ANESTHESIA': 'ანესთეზიის ეპიზოდი',
      'SURGERY': 'ქირურგიული ჩარევა',
      'OPERATION_PROTOCOL': 'ოპერაციის ოქმი'
    };
    return types[type] || type;
  }

  getRecommendationType(type: string): string {
    const types: { [key: string]: string } = {
      'SURGICAL': 'ქირურგიული ჩარევა',
      'INSTRUMENTAL': 'ინსტრუმენტული გამოკვლევა',
      'CONSULTATION': 'კონსულტაცია',
      'OTHER': 'სხვა'
    };
    return types[type] || type;
  }

  getFieldTypeLabel(type: string): string {
    const types: { [key: string]: string } = {
      'text': 'ტექსტი',
      'number': 'რიცხვი',
      'date': 'თარიღი',
      'select': 'არჩევანი',
      'radio': 'რადიო',
      'checkbox': 'ჩეკბოქსი',
      'textarea': 'ტექსტური არე',
      'email': 'ელ-ფოსტა',
      'phone': 'ტელეფონი'
    };
    return types[type] || type;
  }

  getBloodComponentLabel(componentCode: number): string {
    const components: { [key: number]: string } = {
      1: 'ერითროციტული მასა',
      2: 'თრომბოციტული მასა',
      3: 'სისხლის პლაზმა',
      4: 'ფრეშ ფროზენ პლაზმა',
      5: 'კრიოპრეციპიტატი',
      6: 'სრული სისხლი',
      7: 'სხვა'
    };
    return components[componentCode] || `კოდი: ${componentCode}`;
  }

  getFieldOptionLabel(options: any[], value: string | string[] | number | number[]): string {
    if (!options) return '';
    const option = options.find(opt => opt.value === value);
    return option ? option.label : '';
  }
}
